//
//
//
//
//
//
//
//
//
//

export default {
  name: "Country",
  props: {
    countryCode: {
      type: String,
      required: true,
    },
    paths: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      console,
    };
  },
  computed: {},
  watch: {},
  methods: {
    toggleActive() {
      this.$emit("onToggle");
    },
  },
};
